import z from 'zod'

import { zodErrorParser } from '@/utils/zod'
import { BaseEntitySchema } from './Common'
import { UserResponseSchema } from './User'

const CommentResponseSchema = BaseEntitySchema.extend({
  id: z.uuid(),
  alertId: z.uuid(),
  user: UserResponseSchema,
  content: z.string(),
}).strict()

export type CommentResponse = z.infer<typeof CommentResponseSchema>

export const zodCommentResponseValidator = (
  data: CommentResponse[]
) => zodErrorParser(
  'CommentResponse',
  CommentResponseSchema,
  data,
)
